var map = {
	"./cn.json": "./src/locales/cn.json",
	"./en.json": "./src/locales/en.json",
	"./es.json": "./src/locales/es.json",
	"./fr.json": "./src/locales/fr.json",
	"./kr.json": "./src/locales/kr.json",
	"./pt.json": "./src/locales/pt.json",
	"./ru.json": "./src/locales/ru.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";